import React from "react";
import { observable, action } from "mobx";
import * as Api from "api";
import * as User from "api/User";

interface Value {
  currentPassword?: string;
  password?: string;
}

export class AccountFormStore {
  public errors = new Api.Error<User.PasswordParams>(
    "validation.user.password"
  );

  @observable.ref
  public open = false;

  @observable
  public value: Value = {};

  @action.bound
  public modal(open: boolean, value?: Value) {
    this.open = open;
    this.errors.clear();
    this.value = value || {};
  }

  @action.bound
  public async save() {
    this.errors.clear();

    const response = await User.Api.password(this.value);
    if (!response) return false;

    if (response.status === Api.Status.OK) {
      this.modal(false);
      return true;
    }

    this.errors.set(response.data);

    return false;
  }
}

const Context = React.createContext<AccountFormStore | null>(null);

export const AccountFormStoreProvider: React.FC<{
  value?: AccountFormStore;
}> = ({ children, value }) => {
  const accountFormStore = React.useMemo(
    () => (value ? value : new AccountFormStore()),
    [value]
  );
  return (
    <Context.Provider value={accountFormStore}>{children}</Context.Provider>
  );
};

export const useAccountFormStore = () => {
  const accountFormStore = React.useContext(Context);
  if (!accountFormStore) {
    throw new Error(
      "useAccountFormStore must be used within a AccountFormStoreProvider."
    );
  }
  return accountFormStore;
};
